import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Brand from '../components/Brand';
import { validateIdentifier } from '../utils/validators';

function ForgotPassword() {
  const navigate = useNavigate();
  const [method, setMethod] = useState('email');
  const [identifier, setIdentifier] = useState('');
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const clearFieldError = (field) =>
    setErrors((prev) => {
      if (!prev[field]) return prev;
      const next = { ...prev };
      delete next[field];
      return next;
    });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const idErr = validateIdentifier(method, identifier);
    if (idErr) {
      setErrors({ identifier: idErr });
      return;
    }

    setSubmitting(true);
    await new Promise((r) => setTimeout(r, 400));
    setSubmitting(false);

    navigate('/verify-otp', {
      state: {
        flow: 'forgot-password',
        identifier: identifier.trim(),
        method,
      },
    });
  };

  const switchMethod = (next) => {
    setMethod(next);
    setIdentifier('');
    clearFieldError('identifier');
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <Brand />
        <Link to="/login" className="back-link">
          ← Back to login
        </Link>
        <h1 className="auth-title">Reset your password</h1>
        <p className="auth-subtitle">
          We'll send a one-time code to help you reset your password
        </p>

        <div className="tab-switcher">
          <button
            type="button"
            className={`tab-btn ${method === 'email' ? 'active' : ''}`}
            onClick={() => switchMethod('email')}
          >
            Email
          </button>
          <button
            type="button"
            className={`tab-btn ${method === 'phone' ? 'active' : ''}`}
            onClick={() => switchMethod('phone')}
          >
            Phone
          </button>
        </div>

        <form onSubmit={handleSubmit} noValidate>
          <div className="form-group">
            <label className="form-label" htmlFor="fp-identifier">
              {method === 'email' ? 'Email address' : 'Phone number'}
              <span className="required-star"> *</span>
            </label>
            <input
              id="fp-identifier"
              className={`form-input ${errors.identifier ? 'input-error' : ''}`}
              type={method === 'email' ? 'email' : 'tel'}
              autoComplete={method === 'email' ? 'email' : 'tel'}
              placeholder={method === 'email' ? 'you@example.com' : '+1 555 000 0000'}
              value={identifier}
              onChange={(e) => {
                setIdentifier(e.target.value);
                clearFieldError('identifier');
              }}
              aria-invalid={!!errors.identifier}
            />
            {errors.identifier && <div className="field-error">{errors.identifier}</div>}
          </div>

          <button type="submit" className="btn-primary" disabled={submitting}>
            {submitting ? 'Sending OTP…' : 'Send OTP'}
          </button>
        </form>

        <div className="auth-links">
          Remembered your password? <Link to="/login">Sign in</Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
